<template lang="pug">
	
	.posters-overlay
		.poster(v-for="poster in posters")
			img(src="assets/images/poster.jpg")

</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '~utils/scroller.js'
	import Ticker from '~utils/ticker.js'
	import Section from '~abstracts/section'
	import Posters from './posters.json'
	import Globals from '~utils/Globals.js'

	
  @Component({
		name: 'PostersOverlay',
		components: { },
		props: [],
		data: function () {
			return {
				posters : Posters.posters
			}
		}
	})

	class PostersOverlay extends Vue {

		mounted () {
			this._dom()
			
		}
				
		init () {}

		_dom () {
			this.$posters = this.$el.querySelectorAll('.poster')
		}

		initPosters () {
			
			this.tlScroll = new TimelineMax({paused:true})

			this.posters.forEach( (w,i) => {
				
				const left = Globals.responsiveWidth(w.x)
				const top = Globals.responsiveHeight(w.y)
				const height = Globals.responsiveHeight(497)
				const width = Globals.responsiveWidth(350)
				const scale = window.innerWidth / 1440

				TweenMax.set(this.$posters[i],{left: left,top: top,rotationZ: Math.random() * 360 - 180 ,height:height,width:width, zIndex:w.position})
				
				const x = (left + width/2) > window.innerWidth/2 
					? (window.innerWidth/2 + width/2) + Math.random() * window.innerWidth/2
					: -(window.innerWidth/2 + width/2) - Math.random() * window.innerWidth/2

				const y = (top + height/2) > window.innerHeight/2 
					? (window.innerHeight/2 + height/2) + Math.random() * window.innerHeight/2
					: -(window.innerHeight/2 + height/2) - Math.random() * window.innerHeight/2
				
				TweenMax.set(this.$posters[i],{x:x,y:y})
			
			});


		}

		play (ratio) {
			this.tlScroll.progress(ratio)
		}
		

		_resize () {

			this.initPosters()

		}

		update () {

		}

	}

	export default PostersOverlay

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.posters-overlay
		
		width 100vw
		height 100vh
		pointer-events none
		// overflow hidden

		.poster
			position absolute
			width 350px
			height 497px

			img
				width 100%

			&:nth-child(1)
				top 10px
				left -200px
				transform rotateZ(-8deg)
				z-index 1


</style>


// WEBPACK FOOTER //
// poster-overlay.vue?1d3a7488